export enum Language {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FI = 'fi' ,
  FR = 'fr',
  IT = 'it',
  PT = 'pt',
  SV = 'sv'
}

export enum RecordingMode {
  Automatic = 'automatic',
  ClickToTalk = 'clickToTalk',
  PushToTalk = 'pushToTalk'
}

export type RequiredOnSessionInit = {
  serial_number?: boolean;
  features?: string[];
};